import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

interface HoverableCardsSectionItemsContainerProps {
  active: boolean;
}

const activeContainerStyle = css`
  position: relative;
  pointer-events: unset;
  opacity: 1;
  transition: opacity 500ms ease-in-out;
`;

export const HoverableCardsSectionItemsContainer = styled.div<HoverableCardsSectionItemsContainerProps>`
  position: absolute;
  border-radius: 16px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 500ms ease-in-out;
  pointer-events: none;

  ${({ active }) => (active ? activeContainerStyle : '')}
`;

export const HoverableCardsSectionItemsDesktopContent = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  position: relative;
  max-width: 1200px;

  @media all and (max-width: ${layout.md}) {
    display: none;
  }
`;

export const HoverableCardsSectionItemsMobileContent = styled.div`
  display: none;
  grid-template-columns: repeat(2, 1fr);
  position: relative;
  max-width: 600px;

  @media all and (max-width: ${layout.md}) {
    display: grid;
  }
`;

interface HoverableCardsSectionItemsBlockProps {
  background: string;
}

export const HoverableCardsSectionItemsBlock = styled.div<HoverableCardsSectionItemsBlockProps>`
  background: ${({ background }) => background};
  position: relative;
  overflow: hidden;

  .gatsby-image-wrapper {
    position: relative;
    z-index: 1;
    transform: scale(1.02);
    transform-origin: center center;
  }

  .texture-overlay {
    z-index: 2;
    mix-blend-mode: color-burn;
  }
`;

export const HoverableCardsSectionItemBrandContainer = styled.div`
  position: absolute;
  z-index: 3;
  width: 100%;
  bottom: 0;
  display: grid;
  row-gap: 0.75rem;
  grid-template-rows: 1fr 64px;
  padding: 0rem 1rem 2.5rem;
  box-sizing: border-box;

  .brand-image {
    width: 108px;
    border-radius: 16px;
    justify-self: center;
  }

  @media all and (max-width: ${layout.md}) {
    padding: 0rem 1rem 1rem;
    .brand-image {
      // max-width is calculated from border-box container without padding
      max-width: calc((100% + 2rem) * 0.36);
    }
  }
`;
